import { Pipe, PipeTransform } from '@angular/core';
import { getActivityTagLabel } from '../../utils/activity-tags.util';

@Pipe({
  name: 'activityTagLabel',
})
export class ActivityTagLabelPipe implements PipeTransform {
  transform(value: string): string {
    return getActivityTagLabel(value);
  }
}
